import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import styled from 'styled-components';
import { ProductPair } from './product-pair';
import { useProductUpdate } from './api';
import { StatusMessage } from 'components/status-message/status-message';
import { DeviceAction, ProductUpdateRole } from './enums';
import { Loader, PurPurButton } from 'components';
import { icons } from 'theme/icons';
import { Icon } from '@purpurds/purpur/icon';
import { SlideInModal } from 'components/slide-in-modal';
import { purpurColorPurple800 } from '@purpurds/tokens/color/variables';
import spacing from 'theme/spacing';
const UpgradeDowngradeProductContainer = styled.div `
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
`;
const SelectContainer = styled.div `
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;

  @media (max-width: 530px) {
    flex-direction: column;
    gap: 1rem;
  }
`;
const StyledButtonContainer = styled.div `
  width: 170px;

  @media (max-width: 530px) {
    width: 100%;
  }
`;
const StyledButton = styled(PurPurButton) `
  width: 100%;
`;
const DividerContainer = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Divider = styled.div `
  width: 90%;
  border-top: 1px dashed ${purpurColorPurple800};
  margin: ${spacing.spacing16} 0;
`;
export const UpgradeDowngradeProduct = ({ agreementId, customerId, productOptions, isVisible, onClose, }) => {
    const initialProductPair = { id: 1, source: null, target: null, deviceAction: DeviceAction.Return };
    const [productPairs, setProductPairs] = useState([initialProductPair]);
    const resetProductPairs = () => setProductPairs([initialProductPair]);
    const { upgradeDowngradeProducts, isLoading, statusMessage, clearStatusMessage } = useProductUpdate(customerId);
    const isValid = productPairs.every(item => item.source !== null && item.target !== null);
    const addNewPair = () => {
        const newId = productPairs[productPairs.length - 1].id + 1;
        setProductPairs([...productPairs, { id: newId, source: null, target: null, deviceAction: DeviceAction.Return }]);
    };
    const removePair = (id) => {
        if (productPairs.length > 1) {
            setProductPairs(productPairs.filter(pair => pair.id !== id));
        }
    };
    const handleChange = (id, field, value) => {
        const newPairs = productPairs.map((pair) => {
            if (pair.id !== id)
                return pair;
            const updatedPair = Object.assign(Object.assign({}, pair), { [field]: value });
            if (field === ProductUpdateRole.Source) {
                updatedPair.target = null;
            }
            return updatedPair;
        });
        setProductPairs(newPairs);
    };
    const handleUpdate = () => {
        if (!isValid)
            return;
        const data = productPairs
            .map(pair => ({
            type: "ReplaceProduct",
            agreementDetailId: Number(pair.source.value),
            newCommercialProductId: Number(pair.target.value),
            deviceAction: pair.deviceAction === DeviceAction.Transfer ? 'transfer' : 'return',
        }));
        const payload = {
            agreementId: agreementId,
            data: data,
        };
        upgradeDowngradeProducts(payload);
    };
    const handleClose = () => {
        clearStatusMessage();
        resetProductPairs();
        onClose();
    };
    return (_jsx(SlideInModal, { display: isVisible, onClose: handleClose, mainHeading: "Oppgradering/nedgradering", children: _jsx(UpgradeDowngradeProductContainer, { children: isLoading ?
                _jsx(Loader, { size: 56 })
                : (_jsxs(_Fragment, { children: [productPairs.map((productPair, index) => (_jsxs(Fragment, { children: [_jsx(ProductPair, { agreementId: agreementId, options: productOptions, pair: productPair, updateSelection: handleChange, removePair: removePair, hasMultiplePairs: productPairs.length > 1, disabled: isLoading }), productPairs.length > 1 && index < productPairs.length - 1 && (_jsx(DividerContainer, { children: _jsx(Divider, {}) }))] }, productPair.id))), statusMessage &&
                            _jsx(StatusMessage, { type: statusMessage.type, message: statusMessage.message, onDismiss: clearStatusMessage, hasMargins: true }), _jsxs(SelectContainer, { children: [_jsx(StyledButtonContainer, { children: _jsxs(StyledButton, { size: "sm", type: "button", variant: "primary", onClick: addNewPair, children: [_jsx(Icon, { svg: icons.plus, size: "md" }), "Legg til"] }) }), _jsx(StyledButtonContainer, { children: _jsx(StyledButton, { size: "sm", type: "button", variant: "secondary", onClick: handleUpdate, disabled: isLoading || !isValid, children: "Oppdater" }) })] })] })) }) }));
};
